import {
  notEmpty,
  notNullNonNegativeInteger,
  notNullPositiveInteger,
  nullablePositiveInteger
} from 'utils/validations'

type StringOrNull = string | null

type Validations = {
  [key: string]: { validate: (value: StringOrNull) => StringOrNull }
}

const validations: Validations = {
  name: { validate: notEmpty },
  amount: { validate: notNullNonNegativeInteger },
  minimum_invoice_amount: { validate: notNullNonNegativeInteger },
  fine_amount: { validate: notNullNonNegativeInteger },
  duration: { validate: notNullPositiveInteger },
  interval_count: { validate: notNullPositiveInteger },
  penalty_period: { validate: nullablePositiveInteger }
}

export function validate(
  prop: any,
  value: StringOrNull,
  context?: Record<string, any>
): StringOrNull {
  if (!(prop in validations)) return null

  const error = validations[prop].validate(value)
  if (error) return error

  if (prop === 'penalty_period' && value && context?.duration) {
    if (parseInt(value) > parseInt(String(context.duration))) {
      return `Não pode exceder a duração do plano (${context.duration} meses)`
    }
  }

  return null
}
